// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import type {Node} from 'react';

type Props = {
  tabSelected: number,
  tab: number,
  children: Node,
} & any;

const useStyles = props =>
  makeStyles(() => ({
    wrapper: {
      display: props.showTab ? undefined : 'none',
    },
  }));

export default function PageTabWrapper({
  tabSelected,
  tab,
  children,
  ...props
}: Props) {
  const showTab = tabSelected === tab;
  const classes = useStyles({showTab})();
  return (
    <div className={classes.wrapper} {...props}>
      {children}
    </div>
  );
}
